import Vue from "vue";
const _this = new Vue();

export const filters = {
	imgFilter(val) {
		if (val) {
			if (val.includes('data:')) return val
			if (val.length > 100) return val
			val = val.substr(0, 4) == "http" ? val : _this.imageIp + val
			if (val) {
				val = val.replace('img.godear.net', 'mw.tushu.cloud')
			}
		} else {
			val = _this.noImg
		}
		return val;
	},
	// 头像过滤器
	avatarFilter(val) {
		if (val) {
			if (val.includes('data:')) return val
			if (val.length > 100) return val
			val = val.substr(0, 4) == "http" ? val : _this.imageIp + val
			if (val) {
				val = val.replace('img.godear.net', 'mw.tushu.cloud')
			}
		} else {
			val = _this.defaultPhoto
		}
		return val;
	},
	// 定义平台的过滤器，用于将数字转化为平台汉字
	// 0 企业（爱书云）分类 1 淘宝 2 京东 3 天猫 4 苏宁 5 拼多多 7 孔夫子 9 当当 10 快手 12 国美 13 抖音
	platformFilter(shopType) {
		let platformName = "";
		switch (shopType) {
			case 1:
				platformName = "淘宝";
				break;
			case 2:
				platformName = "京东";
				break;
			case 3:
				platformName = "天猫";
				break;
			case 4:
				platformName = "苏宁";
				break;
			case 5:
				platformName = "拼多多";
				break;
			case 7:
				platformName = "孔夫子";
				break;
			case 9:
				platformName = "当当";
				break;
			case 10:
				platformName = "快手";
				break;
			case 12:
				platformName = "国美";
				break;
			case 13:
				platformName = "抖音";
				break;
			case 140:
				platformName = "小红书";
				break;
			case 18:
				platformName = "快团团";
				break;
			default:
				platformName = "-";
		}
		return platformName;
	},
	// 数量数字过滤器
	countFilter(val) {
		if (val === null || val === "" || val === undefined) {
			return "-";
		}
		return val;
	},
	priceTemplateFilter(type) {
		type = Number(type)
		let priceTemplateName = ''
		switch (type) {
		  case 1:
			priceTemplateName = '售价=批销价+批销价*加点+加价+抖动金额'
			break
		  case 2:
			priceTemplateName = '售价=批销价+定价*加点+加价+抖动金额'
			break
		  case 3:
			priceTemplateName = '售价=定价*加点+抖动金额'
			break
		  default:
			priceTemplateName = '-'
		}
		return priceTemplateName
	},
};
